import { ServicePage } from "@/components/ServicePage";

const Fractional = () => (
  <ServicePage
    testid="fractional-page"
    overline="Fractional HR Director"
    titleLines={["Executive HR,", "on retainer."]}
    image="/generated/fractional.png"
    startingAt="Starting at $2,000/mo"
    intro="Too big to run HR off the side of a desk, too lean for a full-time director? Fractional HR leadership gives you 27 years of judgment for a fraction of the cost, steady, senior, and always in your corner."
    defaultService="fractional"
    tiers={[
      { name: "Advisor", price: "Starting at $2,000/mo", who: "For small teams that need a senior voice on call.", features: ["Monthly strategy session", "Email & phone support", "Policy & compliance reviews", "Manager coaching as needed"] },
      { name: "Director", price: "Starting at $3,500/mo", who: "For growing orgs that need hands-on HR leadership.", features: ["Everything in Advisor", "Weekly working sessions", "Investigations oversight", "Pay & performance frameworks", "Hiring & onboarding systems"] },
      { name: "Embedded", price: "Custom", who: "For organizations navigating major change.", features: ["Everything in Director", "On-site availability", "Leadership team partnership", "Org design & restructuring", "Interim leadership coverage"] },
    ]}
    proofPoints={[
      { stat: "Senior by default", label: "You work directly with Susan, not a junior handoff." },
      { stat: "Public + private", label: "Experience across public-sector and private Oregon employers." },
      { stat: "No full-time cost", label: "Executive HR leadership without the executive salary." },
    ]}
    faqs={[
      { q: "How is this different from an HR consultant?", a: "A consultant hands you a report. A fractional director makes the call with you, week over week, as an ongoing part of your leadership team." },
      { q: "Can I change tiers later?", a: "Yes. Most clients start at Advisor or Director and adjust as their needs change. There's no long lock-in." },
      { q: "What does 'starting at' mean?", a: "Retainers begin at the listed rates and scale with scope and hours. We'll set a clear monthly rate on your discovery call." },
    ]}
  />
);

export default Fractional;
